import { render } from "./Noresit.vue?vue&type=template&id=6131f911"
import script from "./Noresit.vue?vue&type=script&lang=js"
export * from "./Noresit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__